import {Notification} from 'element-ui'
import {backstageVer} from '@/config'
import store from '@/store'
let notice = null

export const updateCheck = async () => {
  try {
    let res = await fetch('edition.config.json?r=' + Date.now())
    let edit = await res.json()
    if (backstageVer !== edit.backstageVer) {
      if (!notice) {
        notice = Notification({
          title: '更新提示',
          message: '发现新版本，请刷新页面更新',
          type: 'info',
          duration: 0,
          onClose: () => {
            notice = null
          }
        })
      }
    }
  } catch (e) {
    console.warn('服务器版本号获取失败!')
  }
}

// 权限检查
export const getRoot = async () => {
  const hightRoot = {
    '18048531223': '石锋',
    '13684045763': '周扬',
    '18160030913': '苏尹岚',
    '15908190603': '漆东升',
    '13012345678': 'betatest'
  }
  let root = {
    yunyingMap: {
      ...hightRoot
    },
    memberMap: {},
    highRoot: {
      ...hightRoot
    },
    yunyingLeader: {},
    rootGoodManager: {
      ...hightRoot
    }
  }
  try {
    let res = await fetch('root.json?r=' + Date.now(), {
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      }
    })
    root = await res.json()
    store.commit('setRootMap', {
      yunyingMap: {...hightRoot, ...root.yunyingMap},
      memberMap: {...hightRoot, ...root.memberMap},
      highRoot: {...hightRoot, ...root.highRoot},
      yunyingLeader: {...hightRoot, ...root.yunyingLeader},
      rootGoodManager: {...hightRoot, ...root.rootGoodManager}
    })
  } catch (e) {
    store.commit('setRootMap', {
      yunyingMap: root.yunyingMap,
      memberMap: root.memberMap,
      highRoot: root.highRoot,
      yunyingLeader: root.yunyingLeader,
      rootGoodManager: root.rootGoodManager
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/updateCheck.js